import { Component } from '@angular/core';

@Component({
  selector: 'ng-core-loading',
  styleUrls: ['./loading.component.scss'],
  template: `
    <div class="logo-gif">
      <img alt="loading" src="../../../assets/shared/img/logo_allya.gif">
    </div>
  `
})
export class LoadingComponent {}
